module.exports = __webpack_public_path__ + "media/images/logos/testbrand-logo-2bbb6b8954dcf60271502afcc90ac662.png";